// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groceryBottomBarContainer {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  overflow-x: auto;
  padding: 0.5rem 1rem; /* py-2 px-4 */
  background-color: #ffffff;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.groceryBottomBarContainer::-webkit-scrollbar {
  display: none; /* no-scrollbar */
}

@media (min-width: 1024px) {
  .groceryBottomBarContainer {
    padding-left: 1.25rem; /* px-5 */
    padding-right: 1.25rem; /* px-5 */
  }
}

.bottomBarCustomerNameContainer {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.75rem; /* gap-3 */
  border-right: 1px solid #e2e8f0; /* border-r border-slate-200 */
  padding-right: 1rem; /* pr-4 */
  /* 36px icon + 12px gap + ~80px text ≈ "Walk-In Customer" reference width */
  max-width: 144px;
  min-width: 0;
}

@media (min-width: 1024px) {
  .bottomBarCustomerNameContainer {
    padding-right: 1.25rem; /* pr-5 */
  }
}

.bottomBarCustomerIcon {
  display: flex;
  height: 2.25rem; /* h-9 */
  width: 2.25rem; /* w-9 */
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #eff6ff; /* bg-blue-50 */
  color: #2563eb; /* text-blue-600 */
}

.bottomBarCustomerNameText {
  display: flex;
  flex-direction: column;
  gap: 0.25rem; /* space-y-1 */
  min-width: 0;
  overflow: hidden;
}

.bottomBarCustomerNameValue {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px; /* text-[13px] */
  font-weight: 600; /* font-semibold */
  line-height: 1; /* leading-none */
  color: #1e293b; /* text-slate-800 */
}

.walk-in___customer {
  font-size: 9px; /* text-[9px] */
  line-height: 1; /* leading-none */
  color: #64748b; /* text-slate-500 */
}

.loyalty-points___section {
  display: flex;
  align-items: center;
  font-size: 9px; /* text-[9px] */
  line-height: 1; /* leading-none */
  white-space: nowrap;
}

.loyalty-points___label {
  color: #94a3b8; /* text-slate-400 */
}

.loyalty-points___value {
  margin-left: 0.25rem; /* ml-1 */
  font-weight: 600; /* font-semibold */
  color: #334155; /* text-slate-700 */
}

.bottomBarMiddleContainer {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-around;
  gap: 0.5rem; /* gap-2 */
  padding-left: 0.75rem; /* px-3 */
  padding-right: 0.75rem; /* px-3 */
}

@media (min-width: 1024px) {
  .bottomBarMiddleContainer {
    padding-left: 1.25rem; /* px-5 */
    padding-right: 1.25rem; /* px-5 */
  }
}

.bottomBarDiscountText {
  display: flex;
  flex-direction: column;
  gap: 0.125rem; /* gap-0.5 */
  white-space: nowrap;
}

.bottomBarDiscountText___name {
  font-size: 8px; /* text-[8px] */
  font-weight: 600; /* font-semibold */
  text-transform: uppercase; /* uppercase */
  letter-spacing: 0.05em; /* tracking-wider */
}

.active-grey-text {
  color: #94a3b8; /* text-slate-400 */
}

.active-green-text {
  color: #10b981; /* text-emerald-500 */
}

.bottomBarDiscountText___mrp {
  font-size: 13px; /* text-[13px] */
  font-weight: 700; /* font-bold */
  line-height: 1; /* leading-none */
  color: #1e293b; /* text-slate-800 */
}

@media (min-width: 1024px) {
  .bottomBarDiscountText___mrp {
    font-size: 14px; /* lg:text-[14px] */
  }
}

.bottomBarDiscountValue {
  font-size: 13px; /* text-[13px] */
  font-weight: 700; /* font-bold */
  line-height: 1; /* leading-none */
  color: #059669; /* text-emerald-600 */
}

@media (min-width: 1024px) {
  .bottomBarDiscountValue {
    font-size: 14px; /* lg:text-[14px] */
  }
}

/* ── No active cart banner ── */
.fb-no-active-cart {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.625rem;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  text-align: left;
  border-right: none;
  padding-right: 12px;
}

.fb-no-active-cart:hover {
  background: #ffedd5;
  border-color: #fdba74;
}

.fb-no-active-cart-icon {
  display: flex;
  height: 2.25rem;
  width: 2.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #ffedd5;
  flex-shrink: 0;
}

.fb-no-active-cart-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fb-no-active-cart-label {
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  color: #c2410c;
  white-space: nowrap;
}

.fb-no-active-cart-sub {
  font-size: 9px;
  font-weight: 500;
  line-height: 1;
  color: #ea580c;
  white-space: nowrap;
  opacity: 0.8;
}

.dark .fb-no-active-cart {
  background: rgba(194, 65, 12, 0.12);
  border-color: rgba(194, 65, 12, 0.3);
}
.dark .fb-no-active-cart:hover {
  background: rgba(194, 65, 12, 0.2);
}
.dark .fb-no-active-cart-icon {
  background: rgba(194, 65, 12, 0.2);
}
.dark .fb-no-active-cart-label { color: #fb923c; }
.dark .fb-no-active-cart-sub   { color: #fdba74; }

/* ── GST Invoice badge in bottom bar — icon + label ── */
.fb-gst-badge {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 5px 8px;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  border: 1px solid rgba(255,255,255,0.14);
  border-radius: 10px;
  color: #ffffff;
  cursor: default;
}

.fb-gst-badge svg {
  opacity: 0.85;
  flex-shrink: 0;
}

.fb-gst-badge-label {
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: rgba(255,255,255,0.65);
  line-height: 1;
  text-transform: uppercase;
}

.bottomBarActionButtonContainer {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.5rem; /* gap-2 */
  padding-left: 0.75rem; /* pl-3 */
  border-left: 1px solid #f1f5f9; /* border-l border-slate-100 */
  padding-top: 0.25rem; /* py-1 */
  padding-bottom: 0.25rem; /* py-1 */
}

@media (min-width: 1024px) {
  .bottomBarActionButtonContainer {
    gap: 0.75rem; /* lg:gap-3 */
    padding-left: 1.25rem; /* lg:pl-5 */
  }
}

/* Button overrides to match reference exactly */
.bottomBarActionButtonContainer .customPosButton {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  white-space: nowrap !important;
  min-height: 2.25rem !important; /* min-h-9 */
  height: 44px !important;
  padding: 0.5rem 1.25rem !important; /* py-2 px-5 */
  border-radius: 9999px !important;
  background-color: #2A71FF !important;
  color: #ffffff !important;
  font-size: 14px !important; /* text-[14px] */
  font-weight: 700 !important; /* font-bold */
  box-shadow: 0 10px 15px -3px rgba(42, 113, 255, 0.25), 0 4px 6px -2px rgba(42, 113, 255, 0.25) !important;
  transition: transform 0.2s, background-color 0.2s !important;
  border: 1px solid transparent !important;
}

.bottomBarActionButtonContainer .customPosButton:hover {
  transform: scale(1.02) !important;
  background-color: #155EEF !important;
}

.bottomBarActionButtonContainer .customPosButton:active {
  transform: scale(0.98) !important;
}

.bottomBarActionButtonContainer .customPosButton:disabled {
  opacity: 0.5 !important;
  pointer-events: none !important;
  box-shadow: none !important;
  transform: none !important;
}

.bottomBarActionButtonContainer .customPosButton .customPosButtonContainer {
  display: flex !important;
  align-items: center !important;
  gap: 0.375rem !important; /* gap-1.5 */
}

@media (min-width: 1024px) {
  .bottomBarActionButtonContainer .customPosButton {
    height: 48px !important;
    padding-left: 2rem !important; /* px-8 */
    padding-right: 2rem !important; /* px-8 */
    font-size: 16px !important; /* lg:text-[16px] */
  }

  .bottomBarActionButtonContainer .customPosButton .customPosButtonContainer {
    gap: 0.5rem !important; /* lg:gap-2 */
  }
}

.bottomBarActionButtonContainer .customPosButton .customPosButtonText {
  font-size: inherit !important;
  font-weight: inherit !important;
  color: inherit !important;
}

.bottomBarActionButtonContainer .customPosButton svg {
  pointer-events: none !important;
  flex-shrink: 0 !important;
}

.bottomBarActionButtonContainer .customPosButton svg.lucide-printer {
  width: 18px !important;
  height: 18px !important;
}

@media (min-width: 1024px) {
  .bottomBarActionButtonContainer .customPosButton svg.lucide-printer {
    width: 20px !important;
    height: 20px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/floatingBottombar/FloatingBottom.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB,EAAE,cAAc;EACpC,yBAAyB;EACzB,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,aAAa,EAAE,iBAAiB;AAClC;;AAEA;EACE;IACE,qBAAqB,EAAE,SAAS;IAChC,sBAAsB,EAAE,SAAS;EACnC;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,YAAY,EAAE,UAAU;EACxB,+BAA+B,EAAE,8BAA8B;EAC/D,mBAAmB,EAAE,SAAS;EAC9B,2EAA2E;EAC3E,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB,EAAE,SAAS;EACnC;AACF;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,QAAQ;EACzB,cAAc,EAAE,QAAQ;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,cAAc;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,iBAAiB;EACjC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,cAAc,EAAE,iBAAiB;EACjC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAE,eAAe;EAC/B,cAAc,EAAE,iBAAiB;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW,EAAE,UAAU;EACvB,qBAAqB,EAAE,SAAS;EAChC,sBAAsB,EAAE,SAAS;AACnC;;AAEA;EACE;IACE,qBAAqB,EAAE,SAAS;IAChC,sBAAsB,EAAE,SAAS;EACnC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,YAAY;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,gBAAgB,EAAE,kBAAkB;EACpC,yBAAyB,EAAE,cAAc;EACzC,sBAAsB,EAAE,mBAAmB;AAC7C;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,iBAAiB;EACjC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE;IACE,eAAe,EAAE,mBAAmB;EACtC;AACF;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,iBAAiB;EACjC,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE;IACE,eAAe,EAAE,mBAAmB;EACtC;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;;AAEjD,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,6DAA6D;EAC7D,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW,EAAE,UAAU;EACvB,qBAAqB,EAAE,SAAS;EAChC,8BAA8B,EAAE,8BAA8B;EAC9D,oBAAoB,EAAE,SAAS;EAC/B,uBAAuB,EAAE,SAAS;AACpC;;AAEA;EACE;IACE,YAAY,EAAE,aAAa;IAC3B,qBAAqB,EAAE,YAAY;EACrC;AACF;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,8BAA8B,EAAE,YAAY;EAC5C,uBAAuB;EACvB,kCAAkC,EAAE,cAAc;EAClD,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B,EAAE,gBAAgB;EAC5C,2BAA2B,EAAE,cAAc;EAC3C,yGAAyG;EACzG,4DAA4D;EAC5D,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB,EAAE,YAAY;AACxC;;AAEA;EACE;IACE,uBAAuB;IACvB,6BAA6B,EAAE,SAAS;IACxC,8BAA8B,EAAE,SAAS;IACzC,0BAA0B,EAAE,mBAAmB;EACjD;;EAEA;IACE,sBAAsB,EAAE,aAAa;EACvC;AACF;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".groceryBottomBarContainer {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  overflow-x: auto;\n  padding: 0.5rem 1rem; /* py-2 px-4 */\n  background-color: #ffffff;\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.groceryBottomBarContainer::-webkit-scrollbar {\n  display: none; /* no-scrollbar */\n}\n\n@media (min-width: 1024px) {\n  .groceryBottomBarContainer {\n    padding-left: 1.25rem; /* px-5 */\n    padding-right: 1.25rem; /* px-5 */\n  }\n}\n\n.bottomBarCustomerNameContainer {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.75rem; /* gap-3 */\n  border-right: 1px solid #e2e8f0; /* border-r border-slate-200 */\n  padding-right: 1rem; /* pr-4 */\n  /* 36px icon + 12px gap + ~80px text ≈ \"Walk-In Customer\" reference width */\n  max-width: 144px;\n  min-width: 0;\n}\n\n@media (min-width: 1024px) {\n  .bottomBarCustomerNameContainer {\n    padding-right: 1.25rem; /* pr-5 */\n  }\n}\n\n.bottomBarCustomerIcon {\n  display: flex;\n  height: 2.25rem; /* h-9 */\n  width: 2.25rem; /* w-9 */\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #eff6ff; /* bg-blue-50 */\n  color: #2563eb; /* text-blue-600 */\n}\n\n.bottomBarCustomerNameText {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem; /* space-y-1 */\n  min-width: 0;\n  overflow: hidden;\n}\n\n.bottomBarCustomerNameValue {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 13px; /* text-[13px] */\n  font-weight: 600; /* font-semibold */\n  line-height: 1; /* leading-none */\n  color: #1e293b; /* text-slate-800 */\n}\n\n.walk-in___customer {\n  font-size: 9px; /* text-[9px] */\n  line-height: 1; /* leading-none */\n  color: #64748b; /* text-slate-500 */\n}\n\n.loyalty-points___section {\n  display: flex;\n  align-items: center;\n  font-size: 9px; /* text-[9px] */\n  line-height: 1; /* leading-none */\n  white-space: nowrap;\n}\n\n.loyalty-points___label {\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.loyalty-points___value {\n  margin-left: 0.25rem; /* ml-1 */\n  font-weight: 600; /* font-semibold */\n  color: #334155; /* text-slate-700 */\n}\n\n.bottomBarMiddleContainer {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-around;\n  gap: 0.5rem; /* gap-2 */\n  padding-left: 0.75rem; /* px-3 */\n  padding-right: 0.75rem; /* px-3 */\n}\n\n@media (min-width: 1024px) {\n  .bottomBarMiddleContainer {\n    padding-left: 1.25rem; /* px-5 */\n    padding-right: 1.25rem; /* px-5 */\n  }\n}\n\n.bottomBarDiscountText {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem; /* gap-0.5 */\n  white-space: nowrap;\n}\n\n.bottomBarDiscountText___name {\n  font-size: 8px; /* text-[8px] */\n  font-weight: 600; /* font-semibold */\n  text-transform: uppercase; /* uppercase */\n  letter-spacing: 0.05em; /* tracking-wider */\n}\n\n.active-grey-text {\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.active-green-text {\n  color: #10b981; /* text-emerald-500 */\n}\n\n.bottomBarDiscountText___mrp {\n  font-size: 13px; /* text-[13px] */\n  font-weight: 700; /* font-bold */\n  line-height: 1; /* leading-none */\n  color: #1e293b; /* text-slate-800 */\n}\n\n@media (min-width: 1024px) {\n  .bottomBarDiscountText___mrp {\n    font-size: 14px; /* lg:text-[14px] */\n  }\n}\n\n.bottomBarDiscountValue {\n  font-size: 13px; /* text-[13px] */\n  font-weight: 700; /* font-bold */\n  line-height: 1; /* leading-none */\n  color: #059669; /* text-emerald-600 */\n}\n\n@media (min-width: 1024px) {\n  .bottomBarDiscountValue {\n    font-size: 14px; /* lg:text-[14px] */\n  }\n}\n\n/* ── No active cart banner ── */\n.fb-no-active-cart {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.625rem;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 10px;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  text-align: left;\n  border-right: none;\n  padding-right: 12px;\n}\n\n.fb-no-active-cart:hover {\n  background: #ffedd5;\n  border-color: #fdba74;\n}\n\n.fb-no-active-cart-icon {\n  display: flex;\n  height: 2.25rem;\n  width: 2.25rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #ffedd5;\n  flex-shrink: 0;\n}\n\n.fb-no-active-cart-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.fb-no-active-cart-label {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  color: #c2410c;\n  white-space: nowrap;\n}\n\n.fb-no-active-cart-sub {\n  font-size: 9px;\n  font-weight: 500;\n  line-height: 1;\n  color: #ea580c;\n  white-space: nowrap;\n  opacity: 0.8;\n}\n\n.dark .fb-no-active-cart {\n  background: rgba(194, 65, 12, 0.12);\n  border-color: rgba(194, 65, 12, 0.3);\n}\n.dark .fb-no-active-cart:hover {\n  background: rgba(194, 65, 12, 0.2);\n}\n.dark .fb-no-active-cart-icon {\n  background: rgba(194, 65, 12, 0.2);\n}\n.dark .fb-no-active-cart-label { color: #fb923c; }\n.dark .fb-no-active-cart-sub   { color: #fdba74; }\n\n/* ── GST Invoice badge in bottom bar — icon + label ── */\n.fb-gst-badge {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: 5px 8px;\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  border: 1px solid rgba(255,255,255,0.14);\n  border-radius: 10px;\n  color: #ffffff;\n  cursor: default;\n}\n\n.fb-gst-badge svg {\n  opacity: 0.85;\n  flex-shrink: 0;\n}\n\n.fb-gst-badge-label {\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: rgba(255,255,255,0.65);\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.bottomBarActionButtonContainer {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.5rem; /* gap-2 */\n  padding-left: 0.75rem; /* pl-3 */\n  border-left: 1px solid #f1f5f9; /* border-l border-slate-100 */\n  padding-top: 0.25rem; /* py-1 */\n  padding-bottom: 0.25rem; /* py-1 */\n}\n\n@media (min-width: 1024px) {\n  .bottomBarActionButtonContainer {\n    gap: 0.75rem; /* lg:gap-3 */\n    padding-left: 1.25rem; /* lg:pl-5 */\n  }\n}\n\n/* Button overrides to match reference exactly */\n.bottomBarActionButtonContainer .customPosButton {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  white-space: nowrap !important;\n  min-height: 2.25rem !important; /* min-h-9 */\n  height: 44px !important;\n  padding: 0.5rem 1.25rem !important; /* py-2 px-5 */\n  border-radius: 9999px !important;\n  background-color: #2A71FF !important;\n  color: #ffffff !important;\n  font-size: 14px !important; /* text-[14px] */\n  font-weight: 700 !important; /* font-bold */\n  box-shadow: 0 10px 15px -3px rgba(42, 113, 255, 0.25), 0 4px 6px -2px rgba(42, 113, 255, 0.25) !important;\n  transition: transform 0.2s, background-color 0.2s !important;\n  border: 1px solid transparent !important;\n}\n\n.bottomBarActionButtonContainer .customPosButton:hover {\n  transform: scale(1.02) !important;\n  background-color: #155EEF !important;\n}\n\n.bottomBarActionButtonContainer .customPosButton:active {\n  transform: scale(0.98) !important;\n}\n\n.bottomBarActionButtonContainer .customPosButton:disabled {\n  opacity: 0.5 !important;\n  pointer-events: none !important;\n  box-shadow: none !important;\n  transform: none !important;\n}\n\n.bottomBarActionButtonContainer .customPosButton .customPosButtonContainer {\n  display: flex !important;\n  align-items: center !important;\n  gap: 0.375rem !important; /* gap-1.5 */\n}\n\n@media (min-width: 1024px) {\n  .bottomBarActionButtonContainer .customPosButton {\n    height: 48px !important;\n    padding-left: 2rem !important; /* px-8 */\n    padding-right: 2rem !important; /* px-8 */\n    font-size: 16px !important; /* lg:text-[16px] */\n  }\n\n  .bottomBarActionButtonContainer .customPosButton .customPosButtonContainer {\n    gap: 0.5rem !important; /* lg:gap-2 */\n  }\n}\n\n.bottomBarActionButtonContainer .customPosButton .customPosButtonText {\n  font-size: inherit !important;\n  font-weight: inherit !important;\n  color: inherit !important;\n}\n\n.bottomBarActionButtonContainer .customPosButton svg {\n  pointer-events: none !important;\n  flex-shrink: 0 !important;\n}\n\n.bottomBarActionButtonContainer .customPosButton svg.lucide-printer {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n@media (min-width: 1024px) {\n  .bottomBarActionButtonContainer .customPosButton svg.lucide-printer {\n    width: 20px !important;\n    height: 20px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
